window.CodeClub.maps = {
    au: {
        minZoomLevel: 4,
        lat:-27.51265,
        lng:133.0208382
    },
    nz: {
        minZoomLevel: 5,
        lat:-40.9006,
        lng:174.8860,
        bounds: new google.maps.LatLngBounds(
            new google.maps.LatLng(-50.80902320922895, 164.93238671874997),
            new google.maps.LatLng(-29.25232746830402, -175.16038671875003)
        )
    }
};

$(function() {
    // Responsive menu
    $('#menu-switcher').click(function() {
        var $body = $('body');
        $body.toggleClass('menu-open');
    });

    var url = document.location.toString();
    if (url.match('#')) {
        $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
    }

    // Change hash for page-reload
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        window.location.hash = e.target.hash;
    });

    // Workaround for ReCAPTCHA in modals
    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    }).on('loaded.bs.modal', '.modal', function () {
        if(typeof grecaptcha !== "undefined" && document.getElementById("captcha")) {
            grecaptcha.render("captcha", {sitekey: "6Le6sVQUAAAAAG0o5KuPlZHDeutQF3u8k5PZCEiG"});
        }
    });

    $(".datetimepicker").datetimepicker(window.CodeClub.datetimeConfig);
    $(".datepicker").datetimepicker(window.CodeClub.dateConfig);
    $(".timepicker").datetimepicker(window.CodeClub.timeConfig);

    $('.select').selectize({
        sortField: 'text'
    });

    // Homepage slider
    $('.slider').slick({
        dots: true
    });

    // Modal when viewing audit log information
    $(".audit-log").click(function() {
        var jsonStr = $(this).data('json');
        var jsonPretty = JSON.stringify(jsonStr, null, '    ');

        $(".audit-log-entry").text(jsonPretty);
    });

    // Confirm the user has selected at least one recipient
    $("#sendMessage").click(function() {
        return $(".c-form__input-group-required input[type='checkbox']:checked").length > 0
    });

    // Slider Q and A on the FAQ page
    $(".slide-menu .question").on("click", function() {
        return $(this).parent(".slide-item").toggleClass("open"),
            $(this).siblings(".answer").slideToggle()
    });

    // The "Add a Child" page when the user first signs up
    $("#addChildGroup").click(function() {
        $("#add-child-group-template > .add-child-group").clone().removeClass("u-hidden").insertAfter("#add-child-groups .add-child-group:last");

        $(".datepicker").datetimepicker(window.CodeClub.dateConfig);
        return false;
    });

    // When the user wants to view a report in chart mode
    $(".view-chart").click(function() {
        $(".chart-area").show();
        generateChart('column')
    });

    // Switching report chart types
    $('.switch-chart').click(function () {
        generateChart($(this).data('type'));
        $(".c-button__selected").removeClass("c-button__selected");
        $(this).addClass('c-button__selected');
    });

    // When the user wants to preview how many recipients their message will be sent to
    $("#email_volunteers, #email_leaders, #email_region_id, #email_parents").on("change", function() {
        var data = "ajax=true";
        if($("#email_volunteers").is(":checked")) {
            data += "&recipients[]=volunteers";
        }
        if($("#email_leaders").is(":checked")) {
            data += "&recipients[]=leaders";
        }
        if($("#email_parents").is(":checked")) {
            data += "&recipients[]=parents";
        }

        if($("#email_region_id").val()) {
            $.each($("#email_region_id").val(), function(ix, e) {
                data += "&regions[]="+e;
            });
        }

        $.ajax({
            url: "/ajax/email/count",
            method: "post",
            data: data
        }).done(function (data) {
            if($.isNumeric(data) && data.toLocaleString("en") !== $(".recipient-count").html()) {
                $(".recipient-count").html(data.toLocaleString("en")).addClass("flash");
                setTimeout(function() {
                    $(".recipient-count").removeClass("flash");
                }, 800);

                var buttonID = $(".recipient-count").data('buttonid');
                if (typeof buttonID !== undefined) {
                    var emailStr = 'emails';
                    if (data === 1 ) { emailStr = 'email'; }
                    $('#' + buttonID ).html('Send ' + data.toLocaleString("en") + ' ' + emailStr);
                }

            }
        }).fail(function() {
            alert("Sorry, we couldn't get the total count of recipients.");
        });
    });

    $(".get-involved-link").click(function(e) {
        window.location = $(this).attr("href");
    });

    // When the user previews their email
    $(".preview-email").click(function() {
        event.preventDefault();
        $("#previewForm").find("input").val($("#content").val()).parent().submit();
    });

    // Address autocomplete
    $('.addresscomplete').each(function () {
        $(this).on('destroyaddresscomplete', function () {
            var addressInput = $(this);
            addressInput.removeClass('addresscompleteready').addClass('addresscomplete');
        }).on('startaddresscomplete', function () {
            var addresscomplete,
                addressInput = $(this),
                types = ['address'];

            if($(addressInput).hasClass("schoolautocomplete")) {
                types = ['establishment'];
            }

            addresscomplete = new google.maps.places.Autocomplete(addressInput[0], {
                    types: types,
                    componentRestrictions: { country: window.CodeClub.country }
                }
            );

            addressInput.removeClass('addresscomplete').addClass('addresscompleteready');

            google.maps.event.addListener(addresscomplete, 'place_changed', function () {
                addressInput.trigger('setPosition', addresscomplete.getPlace());
            });
            google.maps.event.addDomListener(addresscomplete, 'keydown', function(e) {
                if (e.keyCode === 13 && $('.pac-container:visible').length) {
                    e.preventDefault();
                }
            });

        }).trigger('startaddresscomplete');
    }).on('setPosition', function (event, data) {
        var componentForm = {
            sublocality_level_1: 'short_name',
            locality: 'short_name',
            route: 'short_name'
        };


        if($("#autocomplete_name").length > 0) {
            $("#autocomplete_name").val(data.name);
        }

        for (var i = 0; i < data.address_components.length; i++) {
            var addressType = data.address_components[i].types[0];

            if($("#region_id").length > 0) {
                var select = $("#region_id").find('option[data-value="'+data.address_components[i].short_name+'"]');
                if(addressType === "administrative_area_level_1" && $(select).length > 0) {
                    $(select).prop('selected', true);
                }
            }

            if (componentForm[addressType] && document.getElementById(addressType)) {
                document.getElementById(addressType).value = data.address_components[i][componentForm[addressType]];
            }
        }

        if (data.geometry.location) {
            $('#addresscomplete_lng').first().val(data.geometry.location.lng());
            $('#addresscomplete_lat').first().val(data.geometry.location.lat());
        }
    });

    // AU: Load all upcoming events and display on the page
    if(document.getElementById("eventbrite-events")) {
        $.ajax({
            "url": "https://www.eventbriteapi.com/v3/events/search/?token=GG7DHPJ6VZZ3DOJ2MYDD&organizer.id=7772588913&sort_by=date",
            "method": "GET"
        }).done(function (data) {
            $("#loading-events").hide();

            $.each(data.events, function(ix, e) {
                var start_date = moment(e.start.local);
                var end_date = moment(e.end.local);
                var title = e.name.text.replace("Getting Started with Coding - Teacher Training @ ", "");
                var temp = '<div class="c-card c-col c-col--4">' +
                    '            <img alt="Shop" class="c-card__image" src="'+e.logo.url+'">' +
                    '            <div class="c-card__body">' +
                    '                <h3>'+title+'</h3>' +
                    '                <p title="'+e.start.timezone+'">'+start_date.format("dddd, MMMM Do YYYY")+'<br>'+start_date.format("h:mma")+' - '+end_date.format("h:mma")+'</p>' +
                    '            </div>' +
                    '            <div class="c-card__footer">' +
                    '                <a class="c-button c-button--hollow c-button--green" href="'+e.vanity_url+'" target="_blank">Secure your spot</a>' +
                    '            </div>' +
                    '        </div>';

                $("#eventbrite-events").append(temp);
            });

            if(data.events.length === 0) {
                $("#no-events").show();
            }
        }).fail(function() {
            $("#loading-events").hide();
            $("#no-events").show();
        });
    }

    if($('.rego-form #user_type').val() === 'volunteer') {
        $('.c-form__label.volunteer_checkbox').hide();
    }
    $('.rego-form #user_type').change(function() {
        let otherTypes = $('.other_type_wrap input')
        otherTypes.each((e, i) => {
            i.checked = false
        })
        if($('.rego-form #user_type').val() === 'venue') {
            $('.host_club_options_wrap').show();
            $('.c-form__label').show()
            $('.c-form__label.venue_checkbox').hide();
        } else {
            $('.host_club_options_wrap' ).hide();
            if ($('.rego-form #user_type').val() === 'volunteer') {
                $('.c-form__label').show()
                $('.c-form__label.volunteer_checkbox').hide();
            } else {
                $('.c-form__label').show()
                $('.c-form__label.parent_checkbox').hide();
            }
        }
    });
});

function generateChart(type) {
    $("#theChart").highcharts({
        data: {
            table: 'datatable'
        },
        chart: {
            type: type,
            style: {
                fontFamily: '"museosansrounded", Calibri, Roboto, Verdana, sans-serif'
            }
        },
        title: {
            text: ''
        },
        yAxis: {
            allowDecimals: false,
            title: {
                text: $("#datatable thead tr th").eq(0).html()
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer'
            }
        },
        xAxis: {
            type: 'category'
        },
        credits: {
            text: 'Code Club'
        }
    });
}